import { InjectionToken } from '@angular/core';
import { MojoNotesService } from 'mojo-irp-notes/lib/mojo-notes.config';

export const NOTES_SERVICE = new InjectionToken<MojoNotesService>('MojoNotesService');
